var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"good-sales"},[_c('Collocation',_vm._g(_vm._b({attrs:{"collocation-info":_vm.collocationInfo,"background-gray":"详情页"}},'Collocation',_vm.$attrs,false),_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }